
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import CustomTable from "../../components/customTable/CustomTable";
// import { mobilequeriesApi } from "../../app/slices/mobileQueriesSlice";
import { OrderQuoteApi } from "../../app/slices/spotGoldQuote/OrderQuoteSlice";
import { toast } from "react-toastify";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
// import DateSearchComponent from "../../components/customTable/DateSearchComponent";
// import CustomTable from "../../components/customTable/CustomTable";
// import { mobilequeriesApi } from "../../app/slices/mobileQueriesSlice";


export default function OrderQuote() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(OrderQuoteApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.OrderQuote.OrderQuote.data);
  const stateLoading = useSelector(
    (state) => state.OrderQuote.loading
  );
  const [showData, setShowData] = useState([]);


  // useEffect(() => {
  //   if (sliceResponse?.length > 0) {
  //     const formattedData = sliceResponse.map((originalData) => {
  //       return {
  //         id: originalData._id,
  //         transaction_Id: originalData.transaction_Id,
  //         orderNo: originalData.order_no || "N/A",
  //         productId: originalData.productDetails[0]?.productId || "N/A",
  //         quantity: originalData.productDetails[0]?.quantity || "N/A",
  //         paymentTypeId: originalData.productDetails[0]?.paymentTypeId || "N/A",
  //         metalType: originalData.metalType || "N/A",
  //         mobileNumber: originalData.mobileNumber || "N/A",
  //         firstName: originalData.firstName || "N/A",
  //         lastName: originalData.lastName || "N/A",
  //         email: originalData.email || "N/A",
  //         customerAddress: originalData.customerAddress || "N/A",
  //         landMark: originalData.landMark || "N/A",
  //         postalCode: originalData.postalCode || "N/A",
  //         stateName: originalData.stateName || "N/A",
  //         cityName: originalData.cityName || "N/A",
  //         shippingAddress: originalData.shippingAddress || "N/A",
  //         shippingLandMark: originalData.shippingLandMark || "N/A",
  //         shippingPostalCode: originalData.shippingPostalCode || "N/A",
  //         shippingStateName: originalData.shippingStateName || "N/A",
  //         shippingCityName: originalData.shippingCityName || "N/A",
  //         panCardNumber: originalData.panCardNumber || "N/A",
  //         dateOfBirth: originalData.dateOfBirth || "N/A",
  //         flag: originalData.flag || "N/A",
  //         customerRefNo: originalData.customerRefNo || "N/A",
  //         status: originalData.status || "N/A",
  //         createdAt: originalData.createdAt || "N/A",
  //         updatedAt: originalData.updatedAt || "N/A",
  //         orderId: originalData.orderId || "N/A"
  //       };
  //     });
  //     setShowData(formattedData);
  //   } else {
  //     setShowData([]);
  //   }
  // }, [sliceResponse]);


  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((originalData) => {
        const firstProduct = Array.isArray(originalData.productDetails) && originalData.productDetails.length > 0
          ? originalData.productDetails[0]
          : {};

        return {
          id: originalData._id,
          transaction_Id: originalData.transaction_Id,
          customerRefNo: originalData.customerRefNo || "N/A",

          // orderNo: originalData.order_no || "N/A",
          productId: firstProduct.productId || "N/A",
          quantity: firstProduct.quantity || "N/A",
          paymentTypeId: firstProduct.paymentTypeId || "N/A",
          metalType: originalData.metalType || "N/A",
          mobileNumber: originalData.mobileNumber || "N/A",
          firstName: originalData.firstName || "N/A",
          lastName: originalData.lastName || "N/A",
          email: originalData.email || "N/A",
          customerAddress: originalData.customerAddress || "N/A",
          landMark: originalData.landMark || "N/A",
          postalCode: originalData.postalCode || "N/A",
          stateName: originalData.stateName || "N/A",
          cityName: originalData.cityName || "N/A",
          shippingAddress: originalData.shippingAddress || "N/A",
          shippingLandMark: originalData.shippingLandMark || "N/A",
          shippingPostalCode: originalData.shippingPostalCode || "N/A",
          shippingStateName: originalData.shippingStateName || "N/A",
          shippingCityName: originalData.shippingCityName || "N/A",
          panCardNumber: originalData.panCardNumber || "N/A",
          dateOfBirth: originalData.dateOfBirth || "N/A",
          flag: originalData.flag || "N/A",
          status: originalData.status || "N/A",
          createdAt: originalData.createdAt || "N/A",
          updatedAt: originalData.updatedAt || "N/A",
          orderId: originalData.orderId || "N/A"
        };
      });
      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);


  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("transaction_Id", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transaction_Id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transaction_Id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transaction_Id}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("orderId", {
      header: "Order ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo || "N/A"}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("productId", {
      header: "Product ID",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.productId}
        </div>
      ),
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.quantity}
        </div>
      ),
    }),
    columnHelper.accessor("paymentTypeId", {
      header: "Payment Type ID",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.paymentTypeId}
        </div>
      ),
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.metalType}
        </div>
      ),
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile Number",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.mobileNumber}
        </div>
      ),
    }),
    columnHelper.accessor("firstName", {
      header: "First Name",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.firstName}
        </div>
      ),
    }),
    columnHelper.accessor("lastName", {
      header: "Last Name",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.lastName}
        </div>
      ),
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.email}
        </div>
      ),
    }),
    columnHelper.accessor("customerAddress", {
      header: "Customer Address",
      size: 200,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.customerAddress}
        </div>
      ),
    }),
    columnHelper.accessor("landMark", {
      header: "Landmark",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.landMark}
        </div>
      ),
    }),
    columnHelper.accessor("postalCode", {
      header: "Postal Code",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.postalCode}
        </div>
      ),
    }),
    columnHelper.accessor("stateName", {
      header: "State Name",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.stateName}
        </div>
      ),
    }),
    columnHelper.accessor("cityName", {
      header: "City Name",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.cityName}
        </div>
      ),
    }),
    columnHelper.accessor("shippingAddress", {
      header: "Shipping Address",
      size: 250,
    }),

    columnHelper.accessor("shippingLandMark", {
      header: "Shipping Landmark",
      size: 200,
    }),

    columnHelper.accessor("shippingPostalCode", {
      header: "Shipping Postal Code",
      size: 50,
    }),

    columnHelper.accessor("shippingStateName", {
      header: "Shipping State Name",
      size: 50,
    }),

    columnHelper.accessor("shippingCityName", {
      header: "Shipping City Name",
      size: 50,
    }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.status}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 50,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),

  ];

  return (
    <>

      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2}>
        <CustomTable columns={columns} data={showData}
          loading={stateLoading}
          permissionKey="SpotGoldQueries"
        />
      </Box>

    </>
  )
}
